import React from "react";
import PlanDetails from "./components/plan-details";

const course1Goals = [
    "غذاء للروح والجسد.",
    "تطوير مهارات في السباحة, حسب قوانين ال FINA.",
    "تعلم التنفس في الماء بشكل سهل وسلس ، بهدف كسب الثقة والسباحة بشكل صح, مضبوط ومريح.",
    "فهم كيفية التعامل مع الجسم داخل الماء بشكل مريح ومفيد.",
    "القدرة على فهم، واستعمال الحركات بطريقة صحيحة ومتقنة.",
    "تعلم طرق للتأقلم في المياه العميقة (لمن تحتاج).",
    "الانتقال للمرحلة الثانية بنجاح, كمرحلة انتقالية ما قبل فرقة التدريب.",
    "التعامل مع تحديات ذاتية وشخصية بشكل مهني ومتفهم.",
    "تحويل السباحة من هواية الى رياضة.",
    "التعليم يتم مع كل امرأة حسب قدراتها وتطورها في التعامل مع الماء.",
    "كذألك يتم ملائمة السباحة لكل امرأة بطريقة تختلف عن الأخرى بهدف الحصول على النتيجة الأمثل."
];
const courseNotes = [
  "التسجيل للدورة يتم بعد دفع مقدمة (400 شيكل) الرجاء عدم الاحراج من لا تدفع المبلغ فهي غير مسجلة بشكل رسمي.",
  "بقية المبلغ يدفع في اللقاء الاول.",
  "يجب تعبئة إستمارة (הצהרת בריאות) قبل بداية دورة السباحة عن طريق تطبيق TRAX.",
  "دخول البركة مشروط بلباس ملائم وطقية للشعر. بهدف الحفاظ على صحتنا وصحة غيرنا.",
  "يتم تصوير كل مشتركة (بعد الموافقة) لغرض التعليم (ليس للنشر)، وتحليل الحركات بشكل شخصي ومهني.",
  "بعد إنتهاء الدرس يتم إرسال نص كلامي وفيديوهات متنوعة ومختلفة تتعلق بفحوى درس السباحة، بهدف تذويت الحركات بالعقل والجسد.",
  "امكانية التعويض حتى 20% من مجمل اللقاءات.",
  "عند تغيب عن اللقاء يتم تعويضه بتنسيق مسبق مع واحده من المجموعات، بحال تمكن ذألك.",
  "(تعويض الدروس يقع على عاتقك)."
]

const courseData = {
  title: "المرحلة الثانية",
  count: "5",
  teamCount: "5",
  duration: "ساعة",
  price: "980",
};

const PremiumPlan = () => {
  return (
    <>

      <div className="container mx-auto lg:px-4">

      <PlanDetails
          title={courseData.title}
          count={courseData.count}
          price={courseData.price}
          teamCount={courseData.teamCount}
          duration={courseData.duration}
        />
      </div>
    </>
  );
};

export default PremiumPlan;
